//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { agentSaleMissingInformationSnoozed } from "store/actions/agentSaleActions";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region components
import { useSnoozeAction } from "components/common";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
//#region store
import { LocalizationHelperInstance } from "utils/helpers";
//#endregion

function useAgentSaleSnoozeAction(id: number, markAsDone: (id: number) => void) {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const onSnoozeSuccess = () => {
    markAsDone && markAsDone(id);
    dispatch(agentSaleMissingInformationSnoozed(id));
  };

  const { snoozeActionDialog, snoozeAction } = useSnoozeAction(
    id,
    WintSuperkollAPIModel.TodoType.AgentSaleMissingInformation,
    onSnoozeSuccess,
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.TodoType_12)
  );

  const onSnoozeClicked = async () => {
    dispatch(displayDialog(snoozeActionDialog));
  };

  return { onSnoozeClicked, snoozeAction };
}

export default useAgentSaleSnoozeAction;
